import React from 'react'
import logo from '../../assets/TweetSpark.png'
import styles from "./Navbar.module.css";

const Navbar = () => {
  return (
    <header className={styles.container}>
      <nav className={styles.nav}>
        <img src={logo} alt="sumz_logo" className={styles.logo} />

        <button
          type="button"
          onClick={() =>
            window.open("https://github.com/PG-257811/TweetSpark", "_blank")
          }
          className="black_btn"
        >
          GitHub
        </button>
      </nav>

      {/* <h1 className="head_text">
        Summarize Articles with <br className="max-md:hidden" />
        <span className="orange_gradient">OpenAI GPT-4</span>
      </h1>
      <h2 className="desc">
        Simplify your reading with Summize, an open-source article summarizer
        that transforms lengthy articles into clear and concise summaries
      </h2> */}
    </header>
  )
}

export default Navbar